import { useFormContext } from "react-hook-form";
import { IParcelaBoletos } from "../../../../Interfaces/Cobranca/ParcelasAbertas/ParcelasAbertas";
import { formatMoneyReais } from "../../../../Tools/FormatTools";

interface IIndicadoresGerarBoletoProps {
    lstParcelas: Array<IParcelaBoletos>;
    lstParcelasMarcadas: Array<IParcelaBoletos>;
    descontos: number;
    honorario: number;
    valorPrincipal: number;
}
export default function IndicadoresGerarBoleto(
    props: IIndicadoresGerarBoletoProps
) {
    const { watch } = useFormContext();
    const FL_ACRESCENTAR_RESIDUOS: boolean = watch("FL_ACRESCENTAR_RESIDUOS");

    const TOTAL = props.lstParcelas.length;
    const NR_SELECIONADO = props.lstParcelasMarcadas.length;
    const SELECIONADO = props.lstParcelasMarcadas.reduce(
        (sum, p) =>
            sum +
            p.ValorReaj +
            (FL_ACRESCENTAR_RESIDUOS ? 1 : 0) *
                ((p.vlrResiduo ?? 0) +
                    (p.vlrMultaResiduo ?? 0) +
                    (p.vlrJurosAtraResiduo ?? 0)),
        0
    );

    const descontos = props.descontos;
    const honorario = props.honorario;
    const valorPrincipal = props.valorPrincipal;

    return (
        <div className="d-flex flex-wrap justify-content-around mr-1">
            {!!TOTAL && (
                <div className="d-flex flex-column mb-1 align-items-center p-2">
                    <span className="text-dark-50 flex-root font-weight-bold">
                        Total de Parcelas
                    </span>
                    <span className="text-dark flex-root font-weight-bold">
                        {TOTAL}
                    </span>
                </div>
            )}
            {!!NR_SELECIONADO && (
                <div className="d-flex flex-column mb-1 align-items-center p-2">
                    <span className="text-dark-50 flex-root font-weight-bold">
                        Parcelas Selecionadas
                    </span>
                    <span className="text-dark flex-root font-weight-bold">
                        {NR_SELECIONADO}
                    </span>
                </div>
            )}
            {!!SELECIONADO && (
                <div className="d-flex flex-column mb-1 align-items-center p-2">
                    <span className="text-dark-50 flex-root font-weight-bold">
                        Valor Selecionado
                    </span>
                    <span className="text-dark flex-root font-weight-bold">
                        {formatMoneyReais(SELECIONADO)}
                    </span>
                </div>
            )}
            {!!descontos || honorario || valorPrincipal ? (
                <div className="d-flex flex-column mb-1 align-items-center p-2">
                    <span className="text-dark-50 flex-root font-weight-bold">
                        Descontos
                    </span>
                    <span className="text-dark flex-root font-weight-bold">
                        {formatMoneyReais(descontos + valorPrincipal)}
                    </span>
                </div>
            ) : null}

            {!!honorario && (
                <div className="d-flex flex-column mb-1 align-items-center p-2">
                    <span className="text-dark-50 flex-root font-weight-bold">
                        Valor Honorário
                    </span>
                    <span className="text-dark flex-root font-weight-bold">
                        {formatMoneyReais(honorario)}
                    </span>
                </div>
            )}
            {!!SELECIONADO && (descontos || honorario || valorPrincipal) ? (
                <div className="d-flex flex-column mb-1 align-items-center p-2">
                    <span className="text-dark-50 flex-root font-weight-bold">
                        Valor com Desconto/Honorário
                    </span>
                    <span className="text-dark flex-root font-weight-bold">
                        {formatMoneyReais(
                            Math.max(
                                SELECIONADO -
                                    descontos +
                                    honorario -
                                    valorPrincipal,
                                0
                            )
                        )}
                    </span>
                </div>
            ) : null}
        </div>
    );
}
